module.exports = __webpack_public_path__ + "static/img/blank.c63f040a.svg";